var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.138 3.288l1.095-1.035A2.51 2.51 0 019.683 5.9L8.587 6.936m-2.189 2.07L5.305 10.04a2.51 2.51 0 01-3.45-3.648L2.95 5.358M4.313 7.527l2.918-2.76",
    stroke: "#000",
    strokeWidth: 1.004,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgLinkIcon;